import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin, errMsg } from "@/lib/api";

const Password = () => {
  const [f, setF] = useState({ current: "", new: "", confirm: "" }), [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (f.new.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.new !== f.confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try { const { data } = await admin.post("/admin/password", { current: f.current, new: f.new }); localStorage.setItem("rv_admin", data.token); setF({ current: "", new: "", confirm: "" }); toast.success("Password changed. Other devices are signed out."); }
    catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="border p-3 space-y-2" data-testid="pw-form"><p className="font-semibold text-sm">Change admin password</p>
      <div className="grid sm:grid-cols-3 gap-2">{[["current", "Current password"], ["new", "New password (8+ characters)"], ["confirm", "Confirm new password"]].map(([k, l]) => <input key={k} type="password" required autoComplete={k === "current" ? "current-password" : "new-password"} placeholder={l} className="border p-2 text-sm" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`pw-${k}`} />)}</div>
      <button disabled={busy} className="bg-gray-900 text-white px-4 py-2 text-sm disabled:opacity-50" data-testid="pw-save">{busy ? "Saving…" : "Change password"}</button>
    </form>
  );
};

const Legacy = () => {
  const [c, setC] = useState(null), [sure, setSure] = useState(false);
  const load = () => admin.get("/admin/legacy").then((r) => setC(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const purge = () => admin.post("/admin/legacy/purge").then((r) => { toast.success(`Removed ${r.data.products} old products and ${r.data.orders} old orders`); setSure(false); load(); }).catch((e) => toast.error(errMsg(e)));
  if (!c) return null;
  const n = c.products + c.orders;
  return (
    <div className="border p-3 space-y-2" data-testid="legacy-panel"><p className="font-semibold text-sm">Old records from the previous website</p>
      <p className="text-sm text-gray-600" data-testid="legacy-count">{n ? `${c.products} old products and ${c.orders} old orders are hidden from your shop and admin.` : "No old records. Your database is clean."}</p>
      {!!n && (sure ? <div className="flex gap-2 items-center"><span className="text-sm text-red-700">Permanently delete them? This can't be undone.</span><button onClick={purge} className="bg-red-600 text-white px-3 py-1.5 text-sm" data-testid="legacy-yes">Yes, delete</button><button onClick={() => setSure(false)} className="border px-3 py-1.5 text-sm">Cancel</button></div>
        : <button onClick={() => setSure(true)} className="border border-red-600 text-red-700 px-3 py-1.5 text-sm" data-testid="legacy-remove">Remove old records</button>)}
    </div>
  );
};

export const SecurityPanel = () => <><Password /><Legacy /></>;
